import content from '../content';

const isUfValid = (uf: string): boolean => {
  return content.states.some((item: string) => item === uf);
};

export default isUfValid;
